import React from 'react';
import {DocDetail} from "states/initialState";
import {FormattedMessage} from "react-intl";

interface DocProps {
  docs: DocDetail[];
  className?: string;
}

const ClosingDocDetail = ({docs, className = ''}: DocProps) => {
  if (docs.length === 0) {
    return <div>{null}</div>
  }

  return (
    <div className={`od ${className}`}>
      <div className='fw-500 mb-3'>
        <FormattedMessage id={"closingDocs." + docs[0].status.toLowerCase()}/>
      </div>
      <ul>
        {docs.map((doc, i) => (
          <div key={i} className="fs-5" style={{whiteSpace: 'pre-line'}}>
            <li>{doc.status === "Rejected" ? `${doc.merchantRequest}${typeof doc.details !== "undefined" ? `\n${doc.details}` : ''}` : doc.merchantRequest}</li>
            <ul>
              <div className="fw-500">
                {doc.status !== "Rejected" && doc.details && <li>{doc.details}</li>}
                {doc.rejectionReason && <li>{doc.rejectionReason}</li>}
              </div>
            </ul>
          </div>
        ))}
      </ul>
    </div>
  )
};

export default ClosingDocDetail;